import type { MetodoTef } from './elgin'

export function metodosDaForma(forma: string, metodos?: string | null): MetodoTef[] {
  const validos: MetodoTef[] = ['PIX', 'CREDIT_CARD', 'DEBIT_CARD']
  const doCsv = (metodos ?? '')
    .split(',')
    .map((s) => s.trim().toUpperCase())
    .filter((m): m is MetodoTef => (validos as string[]).includes(m))

  if (doCsv.length > 0) return doCsv

  if (forma === 'PIX') return ['PIX']

  if (forma === 'CARTAO') return ['CREDIT_CARD', 'DEBIT_CARD']

  return ['CREDIT_CARD']
}
